"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributeRewardRequestToJSON = exports.DistributeRewardRequestFromJSONTyped = exports.DistributeRewardRequestFromJSON = void 0;
function DistributeRewardRequestFromJSON(json) {
    return DistributeRewardRequestFromJSONTyped(json, false);
}
exports.DistributeRewardRequestFromJSON = DistributeRewardRequestFromJSON;
function DistributeRewardRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userIds': json['userIds'],
        'rewardConfigId': json['rewardConfigId'],
    };
}
exports.DistributeRewardRequestFromJSONTyped = DistributeRewardRequestFromJSONTyped;
function DistributeRewardRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userIds': value.userIds,
        'rewardConfigId': value.rewardConfigId,
    };
}
exports.DistributeRewardRequestToJSON = DistributeRewardRequestToJSON;
